import { SRGBColorSpace, WebGLRenderTarget } from "three"
import createSharedCachedFactory from "../../../rx/memo/createSharedCachedFactory"
import useSceneDepthTexture from "./useSceneDepthTexture"

const usePostProcessingRenderTarget = createSharedCachedFactory((engine) => {
  const depthTexture = useSceneDepthTexture(engine)
  const renderTarget = new WebGLRenderTarget(window.innerWidth, window.innerHeight, {
    colorSpace: SRGBColorSpace,
    depthTexture,
  })
  return renderTarget
})

export default usePostProcessingRenderTarget
